/**
 * Contribution Credits — earned from approved map submissions.
 * Credits only discount Map + Calendar subscriptions (auto-apply up to monthly cap).
 * Cash Wallet (payoutBalanceCents) is separate: tour disburse + card top-up.
 */

import { PLAN_IDS, SUBSCRIPTION_PLANS } from './subscriptionPlans';
import { defaultCreditEconomyHelpers } from '../utils/creditEconomyConfig';
import {
  CREDIT_TO_WALLET_CENTS,
  CREDIT_EARN_CENTS,
  FUNDS_EARN_CENTS,
  convertCreditsCentsToWalletCents,
  formatCreditToWalletRateLabel,
  formatCreditsAmount,
  formatCreditExchangeRateLine,
  creditsCentsToCreditUnits,
  TEST_ACCESSIBILITY_APPROVAL_CREDIT_UNITS,
  creditEarnCentsForApproval,
  creditEarnUnitsForApproval,
} from './creditEconomy';

export {
  CREDIT_TO_WALLET_CENTS,
  CREDIT_EARN_CENTS,
  FUNDS_EARN_CENTS,
  convertCreditsCentsToWalletCents,
  formatCreditToWalletRateLabel,
  formatCreditsAmount,
  formatCreditExchangeRateLine,
  creditsCentsToCreditUnits,
  TEST_ACCESSIBILITY_APPROVAL_CREDIT_UNITS,
  creditEarnCentsForApproval,
  creditEarnUnitsForApproval,
};
/** Default-economy cap; prefer useCreditEconomy().maxSubscriptionDiscountCents(...) for live values. */
export const FUNDS_MAX_BILLING_APPLY_CENTS = defaultCreditEconomyHelpers.maxSubscriptionDiscountCents(
  SUBSCRIPTION_PLANS[PLAN_IDS.VRC_MEMBER].priceCents,
);

export const FUNDS_LEDGER_TYPES = {
  EARN: 'earn',
  BILLING_RESERVE: 'billing_reserve',
  BILLING_RELEASE: 'billing_release',
  BILLING_APPLIED: 'billing_applied',
  DONATE: 'donate',
  DONATE_CARD: 'donate_card',
  TRANSFER_OUT: 'transfer_out',
  TRANSFER_IN: 'transfer_in',
  EXCHANGE_TO_WALLET: 'exchange_to_wallet',
};

export const MUTUAL_FUNDS_COLLECTION = 'mutual_funds';
export const USER_FUNDS_HISTORY_COLLECTION = 'funds_history';

/** Canonical community pool — cause voted on later */
export const MAIN_MUTUAL_FUND_ID = 'main';

/** Max Wallet send to another member per transfer (tour disbursements are not capped here). */
export const WALLET_MAX_PEER_TRANSFER_CENTS = 1100;

/** One member-to-member Wallet send per recipient (doc id = recipient uid). */
export const WALLET_PEER_SENDS_COLLECTION = 'wallet_peer_sends';

export const WALLET_PEER_SEND_ONCE_MESSAGE =
  'You can only send Wallet funds to each member once. Use a tour fund disbursement for additional payments.';

export const MAIN_MUTUAL_FUND_DEFAULTS = {
  title: 'VRC Mutual Fund',
  description:
    'The main community pool. Cause is not voted on yet — donations sit here until members choose where they go.',
  goalCents: 0,
  active: true,
  isMain: true,
  causePending: true,
  sortOrder: -1000,
};

export function formatFundsCents(cents) {
  const n = Math.max(0, Math.round(Number(cents) || 0));
  return `$${(n / 100).toFixed(n % 100 === 0 ? 0 : 2)}`;
}

export function clampBillingReserveCents(
  cents,
  availableCents = Infinity,
  maxCents = FUNDS_MAX_BILLING_APPLY_CENTS,
) {
  const n = Math.max(0, Math.round(Number(cents) || 0));
  const avail = Math.max(0, Math.round(Number(availableCents) || 0));
  return Math.min(maxCents, avail, n);
}
